export const getMXLocalDate = (utcDate) => {
  const date = new Date(utcDate);
  const newFormatDate = date.toLocaleString("es-MX", {
    timeZone: "America/Mexico_City", // Mexico City's timezone
    weekday: "long", // Full weekday name
    year: "numeric", // Numeric year
    month: "long", // Full month name
    day: "numeric", // Day of the month
    hour: "2-digit", // 2-digit hour
    minute: "2-digit", // 2-digit minute
    second: "2-digit", // 2-digit second
    hour12: true, // 12-hour clock (AM/PM)
  });
  return newFormatDate;
};
